<!-- <div #expoSpinsAnimationContainer></div> -->
<iframe #expoSpinsAnimationContainer src="pictures/images/poker-web-client/@1x/ExpoSpinAnimation/expoAnime.html"></iframe>
